var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-window-item',[_c('v-card',{staticClass:"mx-2 px-2 pt-2",attrs:{"flat":""}},[_c('CustomText',{attrs:{"color":_vm.pessoa?.cor || 'primary'}},[_vm._t("texto")],2),_c('div',{staticClass:"pa-2"},[_vm._t("body")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }